import { MENU_OPTION_TYPE } from 'consts/enum';
import './menu.scss';

export const MenuTemplate = (model) => {
	const { optionsData } = model;

	const menuOptionHtml = (option) =>
		/* html */
		`
            <li 
                id=${option.id}
                class="engt-menu-option" 
                tabindex=0"
                onkeydown="ENGT_CHAT.onEnterPress()"
                onclick="ENGT_CHAT.triggerMenuOption('${option.title}', '${option.type}', '${option.payload}', '${
			option.id
		}')">
                    <span style="margin-right: 8px;">
                        ${option.icon || ''}
                    </span>
                    <span>${option.title}</span>
            </li>	
    `;

	const getMenuOptions = (allOptions = []) => {
		let allOptionsHtml = '';
		allOptions.forEach((opt) => {
			opt.payload = opt.type === MENU_OPTION_TYPE.URL ? opt.url : opt.payload;
			allOptionsHtml += menuOptionHtml(opt);
		});
		return allOptionsHtml;
	};

	const allMenuHTML = getMenuOptions(optionsData);

	/* html */
	const html = `
		<div id="engtMenuWrapper" class="engt-menu-wrapper engt-menu-wrapper-animate" tabindex="2">
            <ul class="engt-menu-options-wrapper">
                ${allMenuHTML}
            </ul>
        </div>
    `;

	return html;
};
